import { useContext, useMemo, useState, useEffect, useRef } from 'react'
import { DesignContext } from 'contexts/DesignContext'
import objectPath from 'object-path'
import {
  Row,
  Col,
  Form,
  Button,
  Modal,
  ListGroup,
  Image,
} from 'react-bootstrap'
import { Pagination } from '@mui/material'
import { useLocation, useRouteMatch } from 'react-router-dom'
import Label from './Label'
import { Avatar } from '@material-ui/core'
import FeatherIcon from 'feather-icons-react'
import httpClient, { getBaseURL } from 'utility/httpClient.util'
import styles from 'designer/styles/modal.module.css'
import Select from 'react-select'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { checkConditionApi, getApi, setHeadersConfig } from '../action/Api'
import { setRequestFormData } from '../action/Data'
import RViewerJS from 'viewerjs-react'
import 'viewerjs-react/dist/index.css'
import { viewerJsOption } from 'components/Modal/viewerjs.options'
import { cloneDeep } from 'lodash'
import { getFormGroup } from '../action/FormGroup'
dayjs.extend(customParseFormat)

const MEDIA_WIDTH = '120px'
const MEDIA_HEIGHT = '80px'
const MEDIA_PER_PAGE = 10
const DEFAULT_DATE_KEY = 'createdAt'
const PER_PAGE_OPTIONS = [5, 10, 20, 50, 100, 1000]

const Img = (props) => {
  const { fallback = null, src } = props
  const [isBroken, setIsBroken] = useState(false)

  useEffect(() => setIsBroken(false), [src])

  const handleError = () => {
    setIsBroken(true)
  }
  if (isBroken) {
    return fallback
  }

  return <img onError={handleError} {...props} />
}

const SelectedAttachments = ({
  uischema,
  action = {},
  selectedItems = [],
  clearSelectedItem,
  isBrowseGallery,
}) => {
  const viewerjs = useRef()

  if (!selectedItems) return

  let { width = MEDIA_WIDTH, height = MEDIA_HEIGHT } =
    objectPath.get(uischema, 'properties') || {}

  let gallery = selectedItems.map((item, index) => {
    let fileDetail = objectPath.get(item, '@fileDetail') || {}
    let { ext = '', type = '', src = '', fileName } = fileDetail
    if (!type || !ext || !src) return
    let cover
    if (type === 'image') {
      cover = (
        <Img
          src={src}
          className={
            action?.delete?.isEnabled || isBrowseGallery
              ? 'rounded-top'
              : 'rounded'
          }
          style={{
            border: 0,
            display: 'block',
            width: width,
            height: height,
            objectFit: 'cover',
          }}
          fallback={
            <Avatar
              variant="square"
              className={
                action?.delete?.isEnabled || isBrowseGallery
                  ? 'rounded-top'
                  : 'rounded'
              }
              children={<FeatherIcon icon="image" size="25" />}
              style={{
                width: width,
                height: height,
                color: 'darkblack',
                backgroundColor: 'lightgray',
              }}
            />
          }
        />
      )
    } else if (type === 'video') {
      cover = (
        <video
          className={
            action?.delete?.isEnabled || isBrowseGallery
              ? 'rounded-top'
              : 'rounded'
          }
          src={src}
          style={{
            border: 0,
            display: 'block',
            width: width,
            height: height,
            objectFit: 'cover',
          }}
          alt={fileName}
        />
      )
    } else {
      cover = (
        <Avatar
          className={
            action?.delete?.isEnabled || isBrowseGallery
              ? 'rounded-top'
              : 'rounded'
          }
          variant="rounded"
          alt={fileName}
          children={fileName.substring(0, 1)}
          style={{
            width: width,
            height: height,
            fontSize: '24px',
            backgroundColor: 'gray',
          }}
        />
      )
    }

    return (
      <Col xs={'auto'} key={index} className="mb-1 px-1">
        <div>
          <div className="d-flex" style={{ cursor: 'pointer' }}>
            {cover}
          </div>
          <Button
            className="w-100 rounded-bottom py-0"
            variant="danger"
            onClick={() => clearSelectedItem(item, index)}
          >
            <FeatherIcon icon="x" size="13" />
          </Button>
        </div>
      </Col>
    )
  })

  return (
    <Row className="w-100 mx-auto">
      <Col sm="12">
        <hr />
      </Col>
      <Col sm="12">
        <Form.Label className="font-weight-bold">
          {gallery.length} selected files
        </Form.Label>
      </Col>
      <Col sm="12">
        <RViewerJS ref={viewerjs} options={viewerJsOption}>
          <Row className="w-100 mx-auto">{gallery}</Row>
        </RViewerJS>
      </Col>
    </Row>
  )
}

const createType = (contentType) => {
  let type = contentType && contentType.split('/').shift()
  return type
}

const createSrc = (item, uischema, isOriginal = false) => {
  let src = ''
  let baseUrl = getBaseURL()
  if (isOriginal && uischema.originalPath) {
    let { originalPath } = uischema
    originalPath.forEach((value, index) => {
      if (index === 0) {
        if (!value.startsWith('http')) {
          src += baseUrl
        }
        if (!value.startsWith('/')) {
          src += '/'
        }
      }
      if (value.startsWith('@')) {
        let key = value.replace('@', '')
        let mapKey = objectPath.get(item, key)
        src += mapKey
      } else {
        src += value
      }
    })
  } else if (uischema.thumbnailPath) {
    let { thumbnailPath } = uischema
    thumbnailPath.forEach((value, index) => {
      if (index === 0) {
        if (!value.startsWith('http')) {
          src += baseUrl
        }
        if (!value.startsWith('/')) {
          src += '/'
        }
      }
      if (value.startsWith('@')) {
        let key = value.replace('@', '')
        let mapKey = objectPath.get(item, key)
        src += mapKey
      } else {
        src += value
      }
    })
  }
  return src
}

const AttachmentUi = (props) => {
  let {
    action = {},
    deleteItem,
    selectItem,
    isBrowseGallery,
    item,
    index,
    uischema,
  } = props
  let { width = MEDIA_WIDTH, height = MEDIA_HEIGHT } =
    objectPath.get(uischema, 'properties') || {}
  let ext = '',
    type = '',
    src = '',
    fileName
  let attachment =
    objectPath.get(item, 'attachment') || objectPath.get(item, 'Attachment')
  if (attachment) {
    let { fileExtension, key, contentType } = attachment
    fileName = key
    ext = fileExtension
    type = createType(contentType)
    src = createSrc(item, uischema)
  } else {
    let fileDetail = objectPath.get(item, '@fileDetail') || {}
    fileName = fileDetail.fileName
    ext = fileDetail.ext
    type = fileDetail.type
    src = fileDetail.src
  }

  if (!type || !ext || !src) {
    return <></>
  }
  let cover
  if (type === 'image') {
    cover = (
      <Img
        src={src}
        className={
          action?.delete?.isEnabled || isBrowseGallery
            ? 'rounded-top'
            : 'rounded'
        }
        style={{
          border: 0,
          display: 'block',
          width: width,
          height: height,
          objectFit: 'cover',
        }}
        fallback={
          <Avatar
            variant="square"
            className={
              action?.delete?.isEnabled || isBrowseGallery
                ? 'rounded-top'
                : 'rounded'
            }
            children={<FeatherIcon icon="image" size="25" />}
            style={{
              width: width,
              height: height,
              color: 'darkblack',
              backgroundColor: 'lightgray',
            }}
          />
        }
      />
    )
  } else if (type === 'video') {
    cover = (
      <video
        className={
          action?.delete?.isEnabled || isBrowseGallery
            ? 'rounded-top'
            : 'rounded'
        }
        src={src}
        style={{
          border: 0,
          display: 'block',
          width: width,
          height: height,
          objectFit: 'cover',
        }}
        alt={fileName}
      />
    )
  } else {
    src = createSrc(item, uischema, true)
    cover = (
      <Avatar
        className={
          action?.delete?.isEnabled || isBrowseGallery
            ? 'rounded-top'
            : 'rounded'
        }
        variant="rounded"
        alt={fileName}
        children={fileName.substring(0, 1)}
        style={{
          width: width,
          height: height,
          fontSize: '24px',
          backgroundColor: 'gray',
        }}
        onClick={() => window.open(src, '_blank')}
      />
    )
  }
  if (isBrowseGallery) {
    return (
      <Col xs={'auto'} key={index} className="mb-1 px-1">
        <div>
          <div className="d-flex" style={{ cursor: 'pointer' }}>
            {cover}
          </div>
          <Button
            className="w-100 rounded-bottom py-0"
            variant="primary"
            onClick={() => selectItem(item, index)}
          >
            <FeatherIcon icon="check-circle" size="13" />
          </Button>
        </div>
      </Col>
    )
  }
  return (
    <Col xs={'auto'} key={index} className="mb-1 px-1">
      <div>
        <div className="d-flex" style={{ cursor: 'pointer' }}>
          {cover}
        </div>
        {action?.delete?.isEnabled && (
          <Button
            className="w-100 rounded-bottom py-0"
            variant="danger"
            onClick={() => deleteItem(item, index)}
          >
            <FeatherIcon icon="x" size="13" />
          </Button>
        )}
      </div>
    </Col>
  )
}

const FileUi = (props) => {
  let {
    action = {},
    deleteItem,
    selectItem,
    isBrowseGallery,
    item,
    index,
    uischema,
  } = props
  let { width = MEDIA_WIDTH, height = MEDIA_HEIGHT } =
    objectPath.get(uischema, 'properties') || {}
  let file = item
  let isFileType = file instanceof File
  if (!isFileType) return ''
  let { type, name = '' } = file
  let previewType = createType(type)
  let src = URL.createObjectURL(file)
  let fileName = name

  let cover
  if (previewType === 'image') {
    cover = (
      <Image
        id={`${fileName}-image`}
        src={src}
        className={
          action?.delete?.isEnabled || isBrowseGallery
            ? 'rounded-top'
            : 'rounded'
        }
        style={{
          border: 0,
          display: 'block',
          width: width,
          height: height,
          objectFit: 'cover',
        }}
        alt={fileName}
      />
    )
  } else if (previewType === 'video') {
    cover = (
      <video
        className={
          action?.delete?.isEnabled || isBrowseGallery
            ? 'rounded-top'
            : 'rounded'
        }
        src={src}
        style={{
          border: 0,
          display: 'block',
          width: width,
          height: height,
          objectFit: 'cover',
        }}
        alt={fileName}
      />
    )
  } else {
    src = createSrc(item, uischema, true)
    cover = (
      <Avatar
        className={
          action?.delete?.isEnabled || isBrowseGallery
            ? 'rounded-top'
            : 'rounded'
        }
        variant="rounded"
        alt={fileName}
        children={fileName.substring(0, 1)}
        style={{
          width: width,
          height: height,
          fontSize: '24px',
          backgroundColor: 'gray',
        }}
        onClick={() => window.open(src, '_blank')}
      />
    )
  }
  return (
    <Col xs={'auto'} key={index} className="mb-1 px-1">
      <div>
        <div className="d-flex" style={{ cursor: 'pointer' }}>
          {cover}
        </div>
        {action?.delete?.isEnabled && (
          <Button
            className="w-100 rounded-bottom py-0"
            variant="danger"
            onClick={() => deleteItem(item, index)}
          >
            <FeatherIcon icon="x" size="13" />
          </Button>
        )}
      </div>
    </Col>
  )
}

const AllAttachment = (props) => {
  let { attachView, viewerjs } = props
  return (
    <RViewerJS ref={viewerjs} options={viewerJsOption}>
      <Row className="w-100 mx-auto">
        {attachView.map((item, index) => {
          if (item['@isDeleted']) return ''
          return <AttachmentUi {...props} item={item} index={index} />
        })}
      </Row>
    </RViewerJS>
  )
}

const FileAttachment = (props) => {
  let { attachView, viewerjs } = props
  return (
    <RViewerJS ref={viewerjs} options={viewerJsOption}>
      <Row className="w-100 mx-auto">
        {attachView.map((item, index) => {
          if (item['@isDeleted']) return ''
          return <FileUi {...props} item={item} index={index} />
        })}
      </Row>
    </RViewerJS>
  )
}

const PaginationAttachment = (props) => {
  let { attachView, viewerjs } = props
  return (
    <RViewerJS ref={viewerjs} options={viewerJsOption}>
      <Row className="w-100 mx-auto">
        {attachView.map((item, index) => {
          return <AttachmentUi {...props} item={item} index={index} />
        })}
      </Row>
    </RViewerJS>
  )
}

const ArrayAttachment = (props) => {
  let { attachView, viewerjs, page } = props
  let index = page - 1
  let item = attachView[index]
  return (
    <RViewerJS ref={viewerjs} options={viewerJsOption}>
      <Row className="w-100 mx-auto">
        <AttachmentUi {...props} item={item} index={index} />
      </Row>
    </RViewerJS>
  )
}

const NormalAttachment = (props) => {
  let { attachView, viewerjs, uischema, perPage, selectedDate } = props

  const defaultPerPage = objectPath.get(uischema, 'properties.perPage')
  const [filterPage, setFilterPage] = useState(1)
  const [filterPerPage, setFilterPerPage] = useState(
    Number(defaultPerPage || MEDIA_PER_PAGE)
  )
  const isFilterDate = objectPath.get(uischema, 'filter.date')

  const perPageOption = useMemo(() => {
    let options = PER_PAGE_OPTIONS
    if (!perPage) return options
    if (options.includes(perPage)) return options
    options.push(perPage)
    options.sort((a, b) => a - b)
    return options
  }, [filterPerPage])

  useEffect(() => {
    if (isFilterDate) {
      setFilterPage(1)
    }
  }, [selectedDate])

  let gallery = attachView.map((item, index) => {
    return <AttachmentUi {...props} item={item} index={index} />
  })

  let result = gallery.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / filterPerPage)
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }
    resultArray[chunkIndex].push(item)
    return resultArray
  }, [])

  let total = gallery.length

  return (
    <>
      {isFilterDate && gallery.length > 0 && (
        <Row className="w-100 mx-auto mb-3">
          <Col sm="6" md="4" lg="2" className="pl-0">
            <Select
              options={perPageOption}
              getOptionLabel={(option) => option}
              getOptionValue={(option) => option}
              onChange={(option) => {
                setFilterPerPage(option)
                setFilterPage(1)
              }}
              value={[filterPerPage]}
            />
          </Col>
          <Col className="d-flex px-0">
            <Pagination
              count={Math.ceil(total / filterPerPage)}
              variant="outlined"
              page={filterPage}
              onChange={(e, value) => setFilterPage(value)}
            />
          </Col>
        </Row>
      )}
      <RViewerJS ref={viewerjs} options={viewerJsOption}>
        <Row className="w-100 mx-auto"> {result[filterPage - 1]}</Row>
      </RViewerJS>
    </>
  )
}

const RenderAttachments = (props) => {
  let { uischema, attachView, isPaginationAPI } = props
  const defaultPerPage = objectPath.get(uischema, 'properties.perPage')
  const viewerjs = useRef()
  const { isFile } = uischema
  if (!attachView) return <></>
  if (isFile) {
    return <FileAttachment {...props} viewerjs={viewerjs} />
  }
  if (!defaultPerPage) {
    return <AllAttachment {...props} viewerjs={viewerjs} />
  }
  if (uischema.showPerPagePanel) {
    return <PaginationAttachment {...props} viewerjs={viewerjs} />
  }
  if (uischema.viewGalleryType) {
    return <ArrayAttachment {...props} viewerjs={viewerjs} />
  }
  if (isPaginationAPI) {
    return <PaginationAttachment {...props} viewerjs={viewerjs} />
  }
  return <NormalAttachment {...props} viewerjs={viewerjs} />
}

const CustomGallery = (props) => {
  const { uischema, config } = props
  let { key, elementWidth, controlId, require, galleryType } = uischema
  const {
    isDynamic = false,
    dynamicData = {},
    isArray,
    dynamicName,
    dynamicIndex,
    arrayName,
  } = config

  const match = useRouteMatch()
  const location = useLocation()
  const search = location.search || []
  const receivePathParams = match.params
  const urlSearchParams = new URLSearchParams(search)
  const receiveQueryParams = Object.fromEntries([...urlSearchParams])
  const allParams = { ...receivePathParams, ...receiveQueryParams }

  const [currentItem, setCurrentItem] = useState({})
  const [currentIndex, setCurrentIndex] = useState(0)

  const defaultPerPage = objectPath.get(uischema, 'properties.perPage')
  const showPerPagePanel =
    objectPath.get(uischema, 'properties.showPerPagePanel') ||
    objectPath.get(uischema, 'showPerPagePanel')
  const filterDateHeight = objectPath.get(
    uischema,
    'properties.filterDateHeight'
  )
  const [isPaginationAPI, setIsPaginationAPI] = useState(false)
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(
    Number(defaultPerPage || MEDIA_PER_PAGE)
  )

  const designContext = useContext(DesignContext)
  const {
    searchData = {},
    jsonForm,
    designerProps,
    elementAction = {},
    setFormData,
    isUiChanged,
    setIsUiChanged,
    datasourceValue = {},
    setDatasourceValue,
    tabParamActive,
    widgetDesign,
  } = designContext
  const allFormGroup = getFormGroup(designContext)

  const uiKey = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name'
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name
        )
        if (uiName) {
          setLabel(uiName.systemValue)
          return uiName.systemName
        }
      }
      return uischema.name
    }
    return uischema.key
  }, [isDynamic])

  const uiName = useMemo(() => {
    if (isDynamic) {
      if (designerProps) {
        let elementName = designerProps.filter(
          ({ propType }) => propType === 'name'
        )
        let uiName = elementName.find(
          ({ prop }) => `@${prop}` === uischema.name
        )
        if (uiName) {
          setLabel(uiName.systemValue)
          return uiName.systemName
        }
      }
    }
    if (isArray) {
      return `@${arrayName}.${uischema.name}`
    }
    return uischema.name
  }, [isDynamic])

  const fieldName = isArray
    ? `@${arrayName}.${uischema.name}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.name}`
    : uischema.name
  const fieldKey = isArray
    ? `@${arrayName}.${uischema.key}`
    : isDynamic
    ? `${dynamicName}.${dynamicIndex}.${uischema.key}`
    : uischema.key

  const currentSearch = useMemo(() => {
    let fieldSearch = objectPath.get(jsonForm, 'search.field') || []
    let found = fieldSearch.find(({ key }) => key === uiKey)
    return found ? true : false
  }, [uiKey])

  let hasRequire = objectPath.has(elementAction, ['isRequire', key])
  let requireMessage = objectPath.get(elementAction, ['isRequire', key])
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire || require
  const isBrowseGallery = galleryType === 'browse'
  const isFilterDate = objectPath.get(uischema, 'filter.date')
  const filterDateKey = objectPath.get(uischema, 'filter.dateKey')
  const action = objectPath.get(uischema, 'action') || {}
  const dataset = objectPath.get(jsonForm, 'dataset') || []
  const mapTag = objectPath.get(jsonForm, 'schema.mapTag') || []
  const modal = objectPath.get(jsonForm, 'designerPropsData.modal')

  const designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  const formData = jsonForm.formData
  const data = isDynamic ? dynamicData : currentSearch ? searchData : formData
  const dataAttachments =
    objectPath.get(data, uiKey) || objectPath.get(data, uiName) || []

  const attachments = dataAttachments
  const uiChanged = objectPath(isUiChanged)
  const isAPI = uiChanged.get([uischema.key, 'isAPI'])
  const isRefresh = uiChanged.get([uischema.key, 'isRefresh'])
  const isRender = uiChanged.get([uischema.key, 'isRender'])

  const [attachView, setAttachView] = useState([])
  const [label, setLabel] = useState(null)
  const [selectedItems, setSelectedItems] = useState([])
  const [dateList, setDateList] = useState({})
  const [selectedDate, setSelectedDate] = useState(isFilterDate ? '' : true)
  const [pathParamData, setPathParamData] = useState({})
  const [queryParamData, setQueryParamData] = useState({})

  const updateGalleryAPI = (isAPI = true) => {
    if (uischema.viewGalleryType === 'array') return
    uiChanged.set(uischema.key, { isAPI: isAPI })
    setIsUiChanged(uiChanged.get(''))
  }

  const createDateList = (list = dataAttachments) => {
    let dateList = {}
    let key = filterDateKey || DEFAULT_DATE_KEY
    let fileList = cloneDeep(list)
    fileList.map(async (item) => {
      let { ext = '', src = '', contentType } = item
      let fileName = uischema.fileName
        ? objectPath.get(item, uischema.fileName)
        : ''
      if (!src) {
        src = createSrc(item, uischema)
      }
      if (!ext) {
        if (uischema.fileContentType) {
          ext = objectPath.get(item, uischema.fileExtension)
        } else if (fileName) {
          ext = fileName.split('.').pop()
        }
      } else {
        ext = fileName ? fileName.split('.').pop() : ''
      }
      if (!contentType && uischema.fileContentType) {
        contentType = objectPath.get(item, uischema.fileContentType)
      } else {
        try {
          let response = await httpClient
            .get(src, { method: 'HEAD' })
            .then(({ data }) => data)
            .catch(null)
          if (response) {
            contentType = response.headers.get('content-type')
          }
        } catch (e) {
          if (!(e instanceof Error)) {
            e = new Error(e)
          }
          console.error(e.message)
        } finally {
          let type = contentType && contentType.split('/').shift()
          objectPath.set(item, '@fileDetail.src', src)
          objectPath.set(item, '@fileDetail.type', type)
          objectPath.set(item, '@fileDetail.ext', ext)
          objectPath.set(item, '@fileDetail.fileName', fileName)
        }
      }

      return item
    })

    if (isFilterDate) {
      fileList.forEach((item) => {
        let hasItem = objectPath.has(item, key)
        if (hasItem) {
          let dateItem = objectPath.get(item, key)
          let date = dayjs(dateItem).format('DD/MM/BBBB')
          objectPath.push(dateList, date, item)
        }
      })
      setDateList(dateList)
      let attachView = []
      if (selectedDate) {
        attachView = objectPath.get(dateList, selectedDate) || []
      }
      setAttachView(attachView)
    } else {
      setAttachView(fileList || [])
    }
  }

  useEffect(() => {
    if (!modal) {
      updateGalleryAPI()
    }
  }, [designerPropsData.modal])

  useEffect(() => {
    createDateList()
  }, [filterDateKey])

  useEffect(() => {
    if (dataAttachments) {
      createDateList(dataAttachments)
    }
  }, [JSON.stringify(dataAttachments)])

  const attachmentsLength = attachView.length - 1

  const perPageOption = useMemo(() => {
    let options = PER_PAGE_OPTIONS
    if (!perPage) return options
    if (options.includes(perPage)) return options
    options.push(perPage)
    options.sort((a, b) => a - b)
    return options
  }, [perPage])

  const fetchGallery = () => {
    let apiFetchGroup = objectPath.get(action, 'fetch.apiGroup') || []
    let filterFetchApi = filterApiGroup(apiFetchGroup)
    let promise = new Promise(async (resolve) => {
      let allData = formData
      let promiseFetch = await callAPI(filterFetchApi, formData)
      promiseFetch.forEach((response = {}) => {
        let { status, data = null } = response
        if (status === null) return
        if (data) {
          allData = { ...allData, ...data }
          setFormData(allData)
        }
      })
      resolve(allData)
    })
    promise.then((response) => {
      let dataAttachments = objectPath.get(response, uiKey)
      console.log('dataAttachments', dataAttachments)
      createDateList(dataAttachments)
      let galleryChanged = uiChanged.get(uischema.key) || {}
      uiChanged.del([uischema.key, 'isAPI'])
      uiChanged.set(uischema.key, {
        ...galleryChanged,
        isRender: true,
        dataAttachments,
      })
      setIsUiChanged(uiChanged.get(''))
    })
  }

  const [pathParamList = [], queryParamList = []] = useMemo(() => {
    let pathParamList = []
    let queryParamList = []
    let apiFetchGroup = objectPath.get(action, 'fetch.apiGroup') || []
    apiFetchGroup.forEach(({ pathParams, queryParams }) => {
      if (pathParams) {
        let filterPathParams = pathParams.filter(
          ({ propType }) => propType === 'input'
        )
        pathParamList = [...pathParamList, ...filterPathParams]
      }
      if (queryParams) {
        let filterQueryParams = queryParams.filter(
          ({ propType }) => propType === 'input'
        )
        queryParamList = [...queryParamList, ...filterQueryParams]
      }
    })
    return [pathParamList, queryParamList]
  }, [uischema.key])

  useEffect(() => {
    let pathChange = false
    pathParamList.forEach(({ key }) => {
      let oldValue = objectPath.get(pathParamData, key)
      let newValue = objectPath.get(data, key)
      if (oldValue !== newValue) {
        objectPath.set(pathParamData, key, newValue)
        pathChange = true
      }
    })
    setPathParamData(pathParamData)
    let queryChange = false
    queryParamList.forEach(({ key }) => {
      let oldValue = objectPath.get(queryParamData, key)
      let newValue = objectPath.get(data, key)
      if (oldValue !== newValue) {
        objectPath.set(queryParamData, key, newValue)
        queryChange = true
      }
    })
    setQueryParamData(queryParamData)
    if (pathChange || queryChange) {
      updateGalleryAPI()
    }
  }, [JSON.stringify(data)])

  useEffect(() => {
    if (!isFilterDate) {
      updateGalleryAPI()
    }
  }, [isFilterDate])

  useEffect(() => {
    if (isAPI) {
      fetchGallery()
    } else if (isAPI === false) {
      setTotal(attachView.length)
    } else {
      if (isRefresh) {
        let attachView
        if (selectedDate && objectPath.get(dateList, selectedDate)) {
          attachView = objectPath.get(dateList, selectedDate)
        }
        if (attachView) {
          setAttachView(attachView)
        } else {
          let dataAttachments = uiChanged.get([uischema.key, 'dataAttachments'])
          createDateList(dataAttachments)
        }

        uiChanged.del([uischema.key, 'isRefresh'])
        setIsUiChanged(uiChanged.get(''))
      }
    }
  }, [isAPI])

  useEffect(() => setTotal(attachView.length), [attachView.length])

  const [total, setTotal] = useState(attachView.length)
  const [isOpen, setIsOpen] = useState(false)

  const onOpen = () => setIsOpen(true)
  const onHide = () => setIsOpen(false)

  const gotoPrevious = () => {
    setCurrentIndex((prevState) => {
      let index = prevState - 1
      setCurrentItem(attachView[index])
      return index
    })
  }

  const gotoNext = () => {
    setCurrentIndex((prevState) => {
      let index = prevState + 1
      setCurrentItem(attachView[index])
      return index
    })
  }

  const gotoItem = (item, index) => {
    onOpen()
    setCurrentIndex(index)
    setCurrentItem(item)
  }

  const selectItem = (item, index) => {
    selectedItems.push(item)
    setSelectedItems(selectedItems)
    console.log('GALLERY: select item', index, item)
    objectPath.set(formData, `@browseGallery.${uischema.key}`, selectedItems)
    setFormData(formData)
    uiChanged.set(uischema.key, { isRender: true })
    setIsUiChanged(uiChanged.get(''))
  }

  const clearSelectedItem = (item, index) => {
    objectPath.del(selectedItems, index)
    setSelectedItems(selectedItems)
    console.log('GALLERY: clear item', index, item)
    objectPath.set(formData, `@browseGallery.${uischema.key}`, selectedItems)
    setFormData(formData)
    uiChanged.set(uischema.key, { isRender: true })
    setIsUiChanged(uiChanged.get(''))
  }

  const setRequestData = (action, file, formData) => {
    let requestBody = {}
    let { requestDataType } = action
    if (requestDataType === 'customData') {
      let { customData = [] } = action
      customData.forEach(
        ({ request, propType, value, key = '', isDynamic = false }) => {
          if (propType === '') {
            value = objectPath.get(file, request)
          } else if (isDynamic) {
            value = objectPath.get(formData, request)
          } else if (propType === 'input') {
            value = objectPath.has(formData, key)
              ? objectPath.get(formData, key)
              : objectPath.get(formData, request)
          } else if (propType === 'system') {
            value = objectPath.get(formData, key)
          } else if (propType === 'urlParam') {
            value = objectPath.get(allParams, key)
          } else if (propType === 'datasource') {
            value = objectPath.get(datasourceValue, value)
          } else if (propType === 'dataset') {
            let foundDataset = dataset.find((data) => data.key === key)
            if (foundDataset) {
              let datasetValue = []
              let { elementKey, elementName, fields } = foundDataset
              let elementData = objectPath.has(formData, elementKey)
                ? objectPath.get(formData, elementKey)
                : objectPath.get(formData, elementName) || []
              elementData.forEach((rowData, index) => {
                fields.forEach(({ field, valueType, value }) => {
                  if (valueType === 'system') {
                    let rowValue = objectPath.get(rowData, field)
                    objectPath.set(datasetValue, `${index}.${field}`, rowValue)
                  } else if (valueType === 'custom') {
                    objectPath.set(datasetValue, `${index}.${field}`, value)
                  }
                })
              })
              value = datasetValue
            } else {
              value = null
            }
          } else if (propType === 'dateTime') {
            let now = null
            if (value === 'currentDate') {
              now = dayjs().format('YYYY-MM-DD')
            } else if (value === 'currentTime') {
              now = dayjs().format('HH:mm:ss')
            } else if (value === 'currentDateTime') {
              now = dayjs().format('YYYY-MM-DD HH:mm:ss')
            }
            value = now
          }
          if (value === 'true') {
            objectPath.set(requestBody, request, true)
          } else if (value === 'false') {
            objectPath.set(requestBody, request, false)
          } else if (value === 'null') {
            objectPath.set(requestBody, request, null)
          } else {
            let isTable = objectPath.get(mapTag, [key]) === 'table'
            if (isTable && value) {
              value.map((item) => {
                objectPath.del(item, 'tableData')
                return item
              })
            }
            objectPath.set(requestBody, request, value)
          }
        }
      )
    } else if (requestDataType === 'formData') {
      let formDataList = action?.formDataList
      if (formDataList) {
        formDataList.forEach(({ key }) => {
          let form = allFormGroup.find((form) => form.key === key)
          if (!form) return requestBody
          if (form.isGroup) {
            let groupData = form.groupData || []
            groupData.forEach((subGroup) => {
              requestBody = setRequestFormData(subGroup, {
                datasourceValue,
                requestBody,
                formData,
                allParams,
                jsonForm,
              })
            })
          } else {
            requestBody = setRequestFormData(form, {
              datasourceValue,
              requestBody,
              formData,
              allParams,
              jsonForm,
            })
          }
        })
      }
    } else if (requestDataType === 'file') {
      let rawFile = objectPath.get(formData, `@browseFile.${uischema.key}`)
      const fileData = new FormData()
      fileData.append('file', rawFile)
      requestBody = fileData
    }
    console.log('GALLERY: requestBody', requestBody)
    return requestBody
  }

  const getData = async (action, fileId, formData) => {
    let { customName, dataKey = '', pagination, dataTable } = action
    let api = getApi(action, {
      formData,
      fileId,
      page: page,
      perPage: perPage,
      designContext,
    })
    if (!api) return
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .get(api, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    if (response?.status !== 200) {
      let propType = objectPath.get(designerPropsData, `propType`) || {}
      let filterProp = Object.keys(propType)
      filterProp.forEach((key) => {
        let [componentKey, dataKey] = key.split('/')
        if (propType[key] === 'formData') {
          objectPath.set(
            designerPropsData,
            `data.${componentKey}.${dataKey}`,
            {}
          )
        } else {
          objectPath.set(
            designerPropsData,
            `data.${componentKey}.${dataKey}`,
            ''
          )
        }
      })
      return response
    }
    let responseData = objectPath.get(response.data, dataKey)
    objectPath.set(datasourceValue, `${action.key}`, responseData)
    setDatasourceValue(datasourceValue)

    if (pagination) {
      if (pagination?.page) {
        let value = objectPath.get(response.data, pagination?.page)
        setPage(value)
      }
      if (pagination?.perPage) {
        let value = objectPath.get(response.data, pagination?.perPage)
        setPerPage(value)
      }
      if (pagination?.total) {
        let value = objectPath.get(response.data, pagination?.total)
        setTotal(value)
      }
    }
    if (pagination && pagination?.page && pagination?.perPage) {
      setIsPaginationAPI(true)
    } else {
      setIsPaginationAPI(false)
    }
    let internalSchema =
      objectPath.get(action, 'internalApi.schema.properties') || {}
    // set form data
    dataTable.forEach(
      ({
        response,
        key,
        dynamicName,
        isDynamic,
        isComponentData,
        componentName,
      }) => {
        let value = objectPath.get(responseData, response)
        let valueType = internalSchema[response]?.type
        if (value === undefined) {
          if (valueType === 'string') {
            value = ''
          } else if (valueType === 'array') {
            value = []
          } else if (valueType === 'object') {
            value = {}
          } else {
            value = null
          }
        }
        if (isDynamic) {
          objectPath.set(formData, dynamicName, value)
        } else if (isComponentData) {
          objectPath.set(formData, `${componentName}.${response}`, value)
        } else if (key && response) {
          objectPath.set(formData, key, value)
        } else if (response) {
          objectPath.set(formData, response, value)
        }
      }
    )
    if (customName) {
      objectPath.set(formData, `props.${formData}`, responseData || {})
    }
    objectPath.set(response, 'data', formData)
    return response
  }

  const postData = async (action, fileId, file, formData) => {
    // set api
    let api = getApi(action, {
      formData,
      fileId,
      designContext,
    })
    if (!api) return {}
    // set request body
    let requestData = setRequestData(action, file, formData)

    if (!requestData) return {}
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .post(api, requestData, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const putData = async (action, fileId, file, formData) => {
    // set api
    let api = getApi(action, {
      formData,
      fileId,
      designContext,
    })
    if (!api) return {}
    // set request body
    let requestData = setRequestData(action, file, formData)
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .put(api, requestData, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    return response
  }

  const patchData = async (action, fileId, file, formData) => {
    // set api
    let api = getApi(action, {
      formData,
      fileId,
      designContext,
    })
    if (!api) return {}
    // set request body
    let requestData = setRequestData(action, file, formData)
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .patch(api, requestData, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })

    return response
  }

  const deleteData = async (action, fileId, formData) => {
    // set api
    let api = getApi(action, {
      formData,
      fileId,
      designContext,
    })
    if (!api) return {}
    // set headers config
    let config = setHeadersConfig(action)
    // send request
    let response = await httpClient
      .delete(api, config)
      .then(({ data }) => {
        return { status: 200, data: data, message: 'success' }
      })
      .catch(function (error) {
        if (error.response) {
          return {
            status: error.response.status,
            message: error.response.data,
            data: null,
          }
        }
      })
    return response
  }

  const callAPI = async (filterApi, responseData, fileId, file) => {
    let promiseList = []
    filterApi.map(async (action) => {
      let promise = new Promise(async (resolve, reject) => {
        let response = {}
        let data = null
        let status = null
        let message = ''
        let awaitPromised = await Promise.all(promiseList)
        awaitPromised.forEach(({ data }) => {
          responseData = { ...responseData, ...(data?.data || {}) }
        })
        if (action.method === 'get') {
          response = await getData(action, fileId, formData)
        } else if (action.method === 'post') {
          response = await postData(action, fileId, file, responseData)
        } else if (action.method === 'put') {
          response = await putData(action, fileId, file, responseData)
        } else if (action.method === 'patch') {
          response = await patchData(action, fileId, file, responseData)
        } else if (action.method === 'delete') {
          response = await deleteData(action, fileId, formData)
        }
        if (response) {
          data = response.data
          message = response.message
          status = response.status
        }

        if (status >= 400) {
          reject({
            status: status,
            data: null,
            message: message,
            api: action.api,
            apiName: action.apiName,
          })
        } else {
          resolve({
            status: status,
            data: data,
            message: message,
            api: action.api,
            apiName: action.apiName,
          })
        }
      })
        .then((response) => response)
        .catch((error) => error)
      promiseList.push(promise)
    })
    return await Promise.all(promiseList)
  }

  const filterApiGroup = (apiGroup) => {
    return apiGroup.filter((item) => {
      if (item.method === 'get') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive
        )
      }
      if (item.method === 'post') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive
        )
      }
      if (item.method === 'put') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive
        )
      }
      if (item.method === 'patch') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive
        )
      }
      if (item.method === 'delete') {
        return checkConditionApi(
          item,
          allParams,
          formData,
          datasourceValue,
          tabParamActive
        )
      }
      return false
    })
  }

  const deleteItem = (item) => {
    let action = uischema.action || {}
    let fileIdKey = uischema.fileId
    let fileId = objectPath.get(item, fileIdKey)
    let index = attachments.findIndex(
      (item) => objectPath.get(item, fileIdKey) === fileId
    )
    console.log('GALLERY: deleteItem', fileId)
    if (action?.delete?.isOnAPI) {
      let apiDeleteGroup = objectPath.get(action, 'delete.apiGroup') || []
      let apiFetchGroup = objectPath.get(action, 'fetch.apiGroup') || []
      let filterDeleteApi = filterApiGroup(apiDeleteGroup)
      let filterFetchApi = filterApiGroup(apiFetchGroup)

      let responseData = formData
      let promise = new Promise(async (resolve) => {
        let promiseDelete = await callAPI(
          filterDeleteApi,
          responseData,
          fileId,
          item
        )
        promiseDelete.forEach((response = {}) => {
          let { status, data = null } = response
          if (status === null) return
          if (data) {
            setFormData({ ...formData, ...data })
          }
        })
        let promiseFetch = await callAPI(
          filterFetchApi,
          responseData,
          fileId,
          item
        )
        promiseFetch.forEach((response = {}) => {
          let { status, data = null } = response
          if (status === null) return
          if (data) {
            setFormData({ ...formData, ...data })
          }
        })
        resolve(true)
      })
      promise.then(() => {
        updateGalleryAPI(true)
      })
    } else {
      objectPath.set(attachments, [index, `@isDeleted`], 1)
      objectPath.set(attachments, [index, `deleteMode`], 1)
      objectPath.set(formData, uiKey, attachments)
      objectPath.set(formData, uiName, attachments)
      console.log('GALLERY: deleteItem Array', attachments)
      setFormData(formData)
      uiChanged.set(uischema.key, { isRender: true })
      setIsUiChanged(uiChanged.get(''))
    }
  }

  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window
    return { width, height }
  }

  const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(
      getWindowDimensions()
    )

    useEffect(() => {
      const handleResize = () => {
        setWindowDimensions(getWindowDimensions())
      }
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
  }

  const { height } = useWindowDimensions()

  const renderFile = (item) => {
    let fileDetail = objectPath.get(item, '@fileDetail') || {}
    let { ext = '', type = '', src = '', fileName } = fileDetail
    if (type === 'image') {
      return (
        <div
          className="w-100 h-100 d-flex"
          style={{ overflowY: 'auto', maxHeight: height - 200 }}
        >
          <Img
            src={src}
            className="d-flex m-auto"
            fallback={
              <Avatar
                variant="square"
                className="d-flex m-auto"
                children={<FeatherIcon icon="image" size="100" />}
                style={{
                  width: '100%',
                  height: '100%',
                  color: 'darkblack',
                  backgroundColor: 'lightgray',
                }}
              />
            }
          />
        </div>
      )
    }
    if (type === 'video') {
      return (
        <div
          className="w-100 h-100"
          style={{ overflowY: 'auto', maxHeight: height - 200 }}
        >
          <video
            src={src}
            className="d-flex mx-auto w-100 h-100"
            style={{ objectFit: 'contain' }}
            controls
            alt={fileName}
          />
        </div>
      )
    }
    if (ext === 'pdf' || ext === 'txt') {
      return (
        <iframe frameborder="0" width="100%" height="100%" src={src}></iframe>
      )
    }
    return (
      <iframe
        frameborder="0"
        src={`https://view.officeapps.live.com/op/embed.aspx?src=${src}`}
        width="100%"
        height="100%"
      ></iframe>
    )
  }

  return (
    <Form.Group className="mb-0" controlId={controlId}>
      <Row className="w-100 mx-0">
        <Label
          {...props}
          uischema={uischema}
          label={label}
          isRequire={isRequire}
        />
        <Col sm={elementWidth} className="mt-1 p-0">
          <Row className="w-100 mx-auto mb-3">
            {isFilterDate && Object.keys(dateList).length > 0 && (
              <>
                <Col sm="12">
                  <Form.Label className="font-weight-bold">
                    Filter Date
                  </Form.Label>
                </Col>
                <Col
                  sm="auto"
                  style={{
                    zIndex: 1,
                    height: filterDateHeight,
                    overflowY: 'auto',
                  }}
                >
                  <ListGroup id={`gallery-list-${fieldKey}`}>
                    {Object.keys(dateList).map((date, index) => (
                      <ListGroup.Item
                        id={`gallery-item-${fieldKey}-${index}`}
                        className="p-2"
                        active={date === selectedDate}
                        action
                        value={date}
                        onClick={(e) => {
                          let selectedDate = e.target.value
                          setSelectedDate(selectedDate)
                          let attachView = []
                          if (selectedDate) {
                            attachView =
                              objectPath.get(dateList, selectedDate) || []
                          }

                          setAttachView(attachView)
                        }}
                      >
                        {date}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Col>
              </>
            )}
            <Col className="p-0">
              {!isFilterDate && (
                <>
                  {defaultPerPage ? (
                    <Row className="w-100 mx-auto mb-3">
                      {showPerPagePanel && (
                        <Col sm="6" md="4" lg="2" className="pl-0">
                          <Select
                            id={`gallery-pagination-select-${fieldKey}`}
                            options={perPageOption}
                            getOptionLabel={(option) => option}
                            getOptionValue={(option) => option}
                            onChange={(option) => {
                              setPerPage(option)
                              setPage(1)
                              updateGalleryAPI()
                            }}
                            value={[perPage]}
                          />
                        </Col>
                      )}
                      <Col className="d-flex px-0">
                        <Pagination
                          id={`gallery-pagination-${fieldKey}`}
                          count={Math.ceil(total / perPage)}
                          variant="outlined"
                          page={page}
                          onChange={(e, value) => {
                            setPage(value)
                            updateGalleryAPI()
                          }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </>
              )}

              <div className="section">
                <RenderAttachments
                  uischema={uischema}
                  action={uischema.action}
                  attachView={attachView}
                  gotoItem={gotoItem}
                  deleteItem={deleteItem}
                  selectItem={selectItem}
                  perPage={perPage}
                  page={page}
                  isPaginationAPI={isPaginationAPI}
                  isBrowseGallery={isBrowseGallery}
                  selectedDate={selectedDate}
                />
                {isBrowseGallery && (
                  <SelectedAttachments
                    uischema={uischema}
                    action={uischema.action}
                    gotoItem={gotoItem}
                    selectedItems={selectedItems}
                    selectItem={selectItem}
                    clearSelectedItem={clearSelectedItem}
                    perPage={perPage}
                    page={page}
                    isPaginationAPI={isPaginationAPI}
                    isBrowseGallery={isBrowseGallery}
                  />
                )}
                <Modal
                  show={isOpen}
                  onHide={onHide}
                  fullscreen="true"
                  dialogClassName={styles.modalFullScreen}
                >
                  <Modal.Header closeButton>
                    <Form.Label className="d-flex mb-0 align-items-center">
                      <span className="font-weight-bold">
                        {uischema.fileName
                          ? objectPath.get(currentItem, uischema.fileName)
                          : ''}
                      </span>
                      <span className="pl-2 px-1">
                        [
                        {currentItem?.createdAt
                          ? dayjs(currentItem?.createdAt).format(
                              'ddd, D MMM BBBB HH:mm'
                            )
                          : '-'}
                        ]
                      </span>
                    </Form.Label>
                  </Modal.Header>
                  <Modal.Body>{renderFile(currentItem)}</Modal.Body>
                  <Modal.Footer className="p-3">
                    <div className="d-flex justify-content-start">
                      <Button
                        outline
                        color="primary"
                        disabled={currentIndex === 0}
                        className="mx-50"
                        onClick={gotoPrevious}
                      >
                        <FeatherIcon icon="chevron-left" size="16" />
                        ก่อนหน้า
                      </Button>
                    </div>
                    <div className="d-flex justify-content-start">
                      <Button
                        outline
                        color="primary"
                        disabled={currentIndex === attachmentsLength}
                        className="mx-50"
                        onClick={gotoNext}
                      >
                        <FeatherIcon icon="chevron-right" size="16" /> ถัดไป
                      </Button>
                    </div>
                    <div className="d-flex justify-content-start mr-auto">
                      <Form.Label className="d-flex align-items-center">
                        {currentIndex + 1} / {attachmentsLength + 1}
                      </Form.Label>
                    </div>
                    <div className="d-flex justify-content-end">
                      <Button variant="light" onClick={onHide}>
                        ปิด
                      </Button>
                    </div>
                  </Modal.Footer>
                </Modal>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form.Group>
  )
}

export default CustomGallery
